document.addEventListener("DOMContentLoaded", function () {
  if (!document.body.classList.contains("template-index")) return;

  var filterBar = document.getElementById("filter-bar");
  var filterDropdowns = document.querySelectorAll(".filter-dropdown");
  var dropdownContainers = document.querySelectorAll(".dropdown-button-container");
  var isAnimating = false;
  var modalGeneration = 0;
  var STEP = 5;

  if (!filterBar) return;

  filterBar.classList.add("active");
  dropdownContainers.forEach(function (item) {
    item.classList.add("visible");
  });

  // Get or use the modal created by script-index-product.js
  var modal = document.getElementById("collection-modal");
  if (!modal) {
    modal = document.createElement("div");
    modal.id = "collection-modal";
    // In-flow body swap (not a fixed overlay) — see the matching note in
    // script-index-product.js. The document scrolls over this; index sections
    // are display:none'd while it's open. No padding-top so the collection lands
    // in the same position as the index grid (both sit after the #index-logo slot).
    modal.style.cssText =
      "display:none;width:100%;z-index:var(--z-collection-modal);background:transparent;opacity:1;box-sizing:border-box;";
    var modalInnerEl = document.createElement("div");
    modalInnerEl.id = "collection-modal-inner";
    modal.appendChild(modalInnerEl);
    document.body.appendChild(modal);
  }

  var modalInner = document.getElementById("collection-modal-inner");
  modalInner.style.display = "flex";
  modalInner.style.flexDirection = "column";
  // No min-height floor: it left a trailing blank block below scrollable
  // collections. The footer pins itself via script-footer-visibility.js, so short
  // collections still bottom-align it without forcing a viewport-height container.
  modalInner.style.minHeight = "";

  function appendModalFooter() {
    // No clone: MOVE the one real footer into the modal (matches the product-click
    // path in script-index-product.js). script-footer-visibility.js pins it only
    // when the collection is shorter than the viewport.
    if (typeof window.__footerToModal === "function") window.__footerToModal(modalInner);
  }
  var fixedHeader = document.querySelector("header");
  var mainContent = document.getElementById("MainContent");

  // --- Header helpers ---
  function forceHeaderVisible() {
    if (!fixedHeader) return;
    fixedHeader.style.transition = "opacity 0.3s ease-out";
    fixedHeader.style.opacity = "1";
    fixedHeader.style.pointerEvents = "auto";
    setTimeout(function () { fixedHeader.style.transition = ""; }, 300);
  }

  function restoreHeaderOpacity() {
    if (!fixedHeader) return;
    var contentSection = document.querySelector("#shopify-section-index-content");
    var spacerOffset = contentSection ? contentSection.offsetHeight : (window.innerHeight - 70);
    var progress = spacerOffset > 0 ? Math.min(window.scrollY / spacerOffset, 1) : 1;
    fixedHeader.style.opacity = progress;
    fixedHeader.style.pointerEvents = progress > 0.9 ? "auto" : "none";
  }

  // showModalTitle / hideModalTitle now live in script-functions.js (shared).

  // display:none (not visibility:hidden) so the index sections fully leave the
  // document flow — see the matching note in script-index-product.js.
  function hideSections() {
    var root = mainContent || document;
    root.querySelectorAll("[id^='shopify-section-']").forEach(function (s) {
      if (s.id === 'shopify-section-index-filters') return;
      // Banner persists across the collection modal until dismissed.
      if (s.id === 'shopify-section-index-message') return;
      s.style.display = "none";
    });
    document.querySelectorAll(".product-grid").forEach(function (g) {
      if (!modal.contains(g)) g.style.display = "none";
    });
  }

  function showSections() {
    // Restore section display FIRST, THEN re-home the footer. __footerToHome()
    // re-measures the footer to decide whether to pin it; if it runs while the
    // index sections are still display:none it measures ~0 content and wrongly
    // pins the footer over the reappearing tall home grid (bug P1, mirrors the
    // same fix in script-index-product.js showSections). Restoring display does
    // not clear modalInner, so the one real footer node is intact for the move.
    var root = mainContent || document;
    root.querySelectorAll("[id^='shopify-section-']").forEach(function (s) {
      s.style.display = "";
    });
    document.querySelectorAll(".product-grid").forEach(function (g) {
      if (!modal.contains(g)) g.style.display = "";
    });
    if (typeof window.__footerToHome === "function") window.__footerToHome();
  }

  // --- Tag matching ---
  // Shopify URL-encodes tags: "tech devices" becomes "tech-devices" or "tech+devices" in URLs
  // but the raw tag in data-tags is "tech devices" (with spaces, lowercased by Liquid)
  function normalizeTag(t) {
    return t.replace(/[-+]/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function matchesTag(container, tag) {
    var tags = (container.dataset.tags || "").split(",").map(function (t) { return normalizeTag(t); });
    return tags.indexOf(normalizeTag(tag)) !== -1;
  }

  // --- Extract handle/tag from a menu URL ---
  function extractHandleFromUrl(url) {
    // /collections/all/TAG -> TAG
    var match = url.match(/\/all\/([^/?]+)/);
    if (match) return match[1].toLowerCase();
    // /collections/HANDLE -> HANDLE
    match = url.match(/\/collections\/([^/?]+)/);
    return match ? match[1].toLowerCase() : null;
  }

  // --- Show "NO RESULTS" ---
  function showNoResults() {
    var grid = document.createElement("div");
    grid.className = "product-grid";
    grid.style.cssText = "visibility:visible;";

    var noResultsDiv = document.createElement("div");
    noResultsDiv.style.cssText =
      "position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);color:white;font-family:inherit;letter-spacing:inherit;text-transform:uppercase;z-index:10;";
    noResultsDiv.textContent = "NO RESULTS";

    modalInner.innerHTML = "";
    modalInner.appendChild(grid);
    modalInner.appendChild(noResultsDiv);
    appendModalFooter();
  }

  // buildModalGrid now lives in script-functions.js (shared); call it with this
  // file's modalInner + appendModalFooter.

  // --- Dropdown display update ---
  function updateDropdownDisplay(dropdown) {
    var container = dropdown.closest(".dropdown-button-container");
    var filterGroup = container.closest(".filter-group");
    var displaySpan = container.querySelector(".selected-filter");
    var placeholder = container.querySelector(".filter-placeholder");
    var selectedText = dropdown.options[dropdown.selectedIndex].text;
    displaySpan.textContent = selectedText;

    if (dropdown.value) {
      if (placeholder) placeholder.style.display = "none";

      var textWidth = displaySpan.offsetWidth;
      // Never commit a 0 width: when the bar is display:none (cart open / PDP
      // open) offsetWidth reads 0, which would collapse every absolutely-
      // positioned group to nothing and stack them. Keep the last good width
      // instead — __measureFilterWidths re-runs once the bar is visible again.
      if (textWidth > 0) {
        container.style.width = textWidth + "px";
        dropdown.style.width = textWidth + "px";
        filterGroup.style.width = textWidth + "px";
      }
    } else {
      if (placeholder) {
        placeholder.style.display = "block";
        var placeholderWidth = placeholder.offsetWidth;
        if (placeholderWidth > 0) {
          container.style.width = placeholderWidth + "px";
          dropdown.style.width = placeholderWidth + "px";
          filterGroup.style.width = placeholderWidth + "px";
        }
      }
    }
  }

  // --- Check if a menu URL points to a product page ---
  function isProductUrl(url) {
    return url && url.indexOf("/products/") !== -1;
  }

  // --- Apply filters (pure client-side DOM filtering) ---
  // pushHistory defaults to true. Pass false when called from popstate so we
  // don't push a fresh filterModal entry on top of the one we're restoring —
  // otherwise back-navigation never escapes the filtered collection.
  function applyFilters(pushHistory) {
    if (pushHistory === undefined) pushHistory = true;
    var nameDropdown = document.querySelector("[data-filter='name']");
    var categoryDropdown = document.querySelector("[data-filter='category']");
    var finishDropdown = document.querySelector("[data-filter='finish']");

    var nameFilter = nameDropdown ? nameDropdown.value : "";
    var categoryFilter = categoryDropdown ? categoryDropdown.value : "";
    var finishFilter = finishDropdown ? finishDropdown.value : "";

    if (!nameFilter && !categoryFilter && !finishFilter) return;

    // Check if any active filter points to a product URL — navigate directly
    var allFilterChecks = [
      { value: nameFilter, type: "name" },
      { value: categoryFilter, type: "category" },
      { value: finishFilter, type: "finish" }
    ];
    for (var i = 0; i < allFilterChecks.length; i++) {
      var fc = allFilterChecks[i];
      if (fc.value) {
        var el = document.querySelector("[data-menu-item='" + fc.value + "'][data-menu-type='" + fc.type + "']");
        if (el && isProductUrl(el.getAttribute("data-menu-url"))) {
          // Reset the dropdown that triggered the product navigation so when
          // the user hits Back, the filter bar shows its default state instead
          // of the selection that took them away from the index.
          var resetDropdown = document.querySelector("[data-filter='" + fc.type + "']");
          if (resetDropdown) {
            resetDropdown.value = "";
            updateDropdownDisplay(resetDropdown);
          }
          updateCombinationVisibility();
          updateAvailableOptions();
          updateClearBtn();
          window.location.href = el.getAttribute("data-menu-url");
          return;
        }
      }
    }

    // Build display title
    var filters = [];
    if (nameFilter) filters.push(nameFilter);
    if (categoryFilter) filters.push(categoryFilter);
    if (finishFilter) filters.push(finishFilter);
    var filterTitle = filters.join(" + ");

    // Resolve NAME filter to a tertiary collection handle
    var nameHandle = null;
    if (nameFilter) {
      var nameEl = document.querySelector("[data-menu-item='" + nameFilter + "'][data-menu-type='name']");
      if (nameEl) nameHandle = extractHandleFromUrl(nameEl.getAttribute("data-menu-url"));
    }

    // Resolve CATEGORY filter to a tag
    var categoryTag = null;
    if (categoryFilter) {
      var catEl = document.querySelector("[data-menu-item='" + categoryFilter + "'][data-menu-type='category']");
      if (catEl) categoryTag = extractHandleFromUrl(catEl.getAttribute("data-menu-url"));
    }

    // Resolve FINISH filter to a tag
    var finishTag = null;
    if (finishFilter) {
      var finEl = document.querySelector("[data-menu-item='" + finishFilter + "'][data-menu-type='finish']");
      if (finEl) finishTag = extractHandleFromUrl(finEl.getAttribute("data-menu-url"));
    }

    // Filter all product containers from the main grid
    var allContainers = Array.from(document.querySelectorAll("#product-grid-main .product-grid-image-container"));

    var matched = allContainers.filter(function (c) {
      if (nameHandle) {
        var handles = (c.dataset.tertiaryHandles || "").split(",").map(function (h) { return h.trim(); });
        if (handles.indexOf(nameHandle) === -1) return false;
      }
      if (categoryTag && !matchesTag(c, categoryTag)) return false;
      if (finishTag && !matchesTag(c, finishTag)) return false;
      return true;
    });

    // Open modal immediately
    var gen = ++modalGeneration;
    isAnimating = false;

    // Capture home scroll before the body swap, only on a fresh open (a filter
    // change while already in the modal must not overwrite it). buildModalGrid
    // resets to top; closeModal restores this value.
    if (modal.style.display !== "block") window.__indexHomeScrollY = window.scrollY;

    hideSections();
    var earlyStyle = document.getElementById("cl-deeplink-hide");
    if (earlyStyle) earlyStyle.remove();

    forceHeaderVisible();
    showModalTitle(filterTitle);

    var params = new URLSearchParams(window.location.search);
    params.delete("collection");
    if (nameFilter) params.set("name", nameFilter); else params.delete("name");
    if (categoryFilter) params.set("category", categoryFilter); else params.delete("category");
    if (finishFilter) params.set("finish", finishFilter); else params.delete("finish");
    if (pushHistory) {
      history.pushState(
        { filterModal: true, name: nameFilter, category: categoryFilter, finish: finishFilter },
        "",
        window.location.pathname + (params.toString() ? "?" + params.toString() : "")
      );
    }

    modal.style.background = "transparent";
    modal.style.opacity = "0";
    modal.style.display = "block";
    void modal.offsetHeight;
    modal.style.transition = "opacity 0.3s ease-out";
    modal.style.opacity = "1";
    setTimeout(function () { modal.style.transition = ""; }, 300);

    if (gen !== modalGeneration) return;

    if (matched.length === 0) {
      showNoResults();
      return;
    }

    var modalContainers = buildModalGrid(matched, modalInner, appendModalFooter);

    requestAnimationFrame(function () {
      modalContainers.forEach(function (c) {
        c.style.transition = "opacity 0.9s ease-in-out";
        c.style.opacity = "1";
      });
      setTimeout(function () {
        modalContainers.forEach(function (c) {
          c.style.transition = "";
          c.style.opacity = "";
        });
      }, 950);
    });
  }

  // --- Close modal ---
  function closeModal(updateHistory) {
    if (updateHistory === undefined) updateHistory = true;
    if (isAnimating) return;
    isAnimating = true;
    ++modalGeneration;
    filterBar.classList.remove("close-hover");
    suppressCloseHover = true;

    window.HeaderState.exitModal();

    if (updateHistory) {
      var params = new URLSearchParams(window.location.search);
      params.delete("collection");
      params.delete("name");
      params.delete("category");
      params.delete("finish");
      params.delete("viewall");
      var newUrl = window.location.pathname + (params.toString() ? "?" + params.toString() : "");
      history.pushState({}, "", newUrl);
    }

    var containers = Array.from(
      document.querySelectorAll("#product-grid-main .product-grid-image-container")
    ).filter(function (c) { return c.dataset.inHome === "true"; });

    // Instant reset for popstate navigation — let the browser own the visual transition.
    if (!updateHistory) {
      modal.style.transition = "none";
      modal.style.opacity = "0";
      modal.style.display = "none";
      hideModalTitle();
      viewAllActive = false;
      if (viewAllCloseBtn) viewAllCloseBtn.style.display = "none";
      // Restore sections to flow, then the saved home scroll, then header opacity.
      showSections();
      window.scrollTo(0, window.__indexHomeScrollY || 0);
      restoreHeaderOpacity();
      containers.forEach(function (c) {
        c.style.transition = "none";
        c.style.opacity = "";
      });
      isAnimating = false;
      return;
    }

    // Animated close for user-triggered dismissals.
    containers.forEach(function (c) {
      c.style.transition = "none";
      c.style.opacity = "0";
    });

    modal.style.transition = "opacity 0.3s ease-out";
    modal.style.opacity = "0";

    setTimeout(function () {
      modal.style.transition = "none";
      modal.style.display = "none";
      hideModalTitle();
      viewAllActive = false;
      if (viewAllCloseBtn) viewAllCloseBtn.style.display = "none";

      // Restore sections to flow and the saved home scroll before recomputing
      // header opacity (it reads scrollY + section offsetHeight).
      showSections();
      window.scrollTo(0, window.__indexHomeScrollY || 0);

      requestAnimationFrame(restoreHeaderOpacity);

      requestAnimationFrame(function () {
        containers.forEach(function (c) {
          c.style.transition = "opacity 0.9s ease-in-out";
          c.style.opacity = "1";
        });
      });

      setTimeout(function () {
        containers.forEach(function (c) {
          c.style.transition = "";
          c.style.opacity = "";
        });
        isAnimating = false;
      }, 950);
    }, 300);
  }

  // --- VIEW ALL ---
  var viewAllBtn = document.getElementById("viewall-btn");
  var viewAllCloseBtn = document.getElementById("viewall-close-btn");
  var viewAllActive = false;


  // Opens the VIEW ALL modal. Extracted so popstate can re-open it
  // without animation when the user returns from a PDP that was launched
  // out of VIEW ALL — without this, navigating back from the PDP would
  // fall through to closeModal() and drop the user on the bare index.
  function openViewAll(opts) {
    opts = opts || {};
    var pushHistory = opts.pushHistory !== false;
    var instant = opts.instant === true;

    viewAllActive = true;
    filterBar.classList.add("viewall-active");
    suppressCloseHover = true;
    filterBar.classList.remove("close-hover");
    if (viewAllBtn) viewAllBtn.textContent = "ALL";
    filterDropdowns.forEach(function (dropdown) {
      dropdown.value = "";
      updateDropdownDisplay(dropdown);
    });
    updateClearBtn();
    // Capture home scroll before the body swap, only on a fresh open.
    if (modal.style.display !== "block") window.__indexHomeScrollY = window.scrollY;
    hideSections();
    forceHeaderVisible();

    // History entry so that a subsequent PDP push/back lands BACK on
    // VIEW ALL (popstate handler reads e.state.viewAll) instead of
    // skipping past it to the bare index. The URL carries ?viewall=true so the
    // view is reloadable and shareable (the deep-link init below re-opens it).
    // NOT ?view= — Shopify reserves that for alternate template views (this theme
    // already uses ?view=index-data), so it could collide with template routing.
    // VIEW ALL clears all filters, so strip any stale modal params first.
    if (pushHistory) {
      var vaParams = new URLSearchParams(window.location.search);
      vaParams.delete("collection");
      vaParams.delete("name");
      vaParams.delete("category");
      vaParams.delete("finish");
      vaParams.set("viewall", "true");
      history.pushState({ viewAll: true }, "", window.location.pathname + "?" + vaParams.toString());
    }

    // Fast path: modal is already mounted (instant popstate restore from a
    // PDP that was opened out of VIEW ALL). No rebuild — pmFadeInView is
    // already restoring its opacity, and rebuilding via buildModalGrid here
    // would wipe modalInner.innerHTML, reset scroll, and add a frame of
    // layout work that visibly delays the "ALL" chrome text from feeling
    // restored. Snap the title and modal opacity to their final state and
    // exit.
    if (instant && modal.style.display === "block") {
      modal.style.transition = "none";
      modal.style.opacity = "1";
      showModalTitleInstant("VIEW ALL");
      isAnimating = false;
      ++modalGeneration;
      return;
    }

    showModalTitle("VIEW ALL");

    var allContainers = Array.from(
      document.querySelectorAll("#product-grid-main .product-grid-image-container")
    );

    isAnimating = false;
    var gen = ++modalGeneration;

    modal.style.background = "transparent";
    modal.style.display = "block";
    if (instant) {
      modal.style.transition = "none";
      modal.style.opacity = "1";
    } else {
      modal.style.opacity = "0";
      void modal.offsetHeight;
      modal.style.transition = "opacity 0.3s ease-out";
      modal.style.opacity = "1";
      setTimeout(function () { modal.style.transition = ""; }, 300);
    }

    if (gen !== modalGeneration) return;

    var modalContainers = buildModalGrid(allContainers, modalInner, appendModalFooter);

    if (instant) {
      modalContainers.forEach(function (c) {
        c.style.transition = "none";
        c.style.opacity = "1";
      });
      return;
    }

    requestAnimationFrame(function () {
      modalContainers.forEach(function (c) {
        c.style.transition = "opacity 0.9s ease-in-out";
        c.style.opacity = "1";
      });
      setTimeout(function () {
        modalContainers.forEach(function (c) {
          c.style.transition = "";
          c.style.opacity = "";
        });
      }, 950);
    });
  }

  if (viewAllBtn) {
    viewAllBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      if (viewAllActive) {
        viewAllActive = false;
        filterBar.classList.remove("viewall-active");
        if (viewAllBtn) viewAllBtn.textContent = "VIEW ALL";
        if (viewAllCloseBtn) viewAllCloseBtn.style.display = "none";
        updateClearBtn();
        closeModal();
        return;
      }
      openViewAll();
    });
  }

  if (viewAllCloseBtn) {
    viewAllCloseBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      viewAllActive = false;
      filterBar.classList.remove("viewall-active");
      viewAllCloseBtn.style.display = "none";
      updateClearBtn();
      closeModal();
    });
  }

  function isAnyFilterActive() {
    return viewAllActive
      || filterBar.classList.contains("name-active")
      || Array.from(filterDropdowns).some(function (d) { return d.value !== ""; });
  }

  // --- Negative space click on filter bar clears filters ---
  filterBar.addEventListener("click", function (e) {
    if (!viewAllActive && e.target.closest("#filter-groups-wrapper")) return;
    if (!isAnyFilterActive()) return;
    e.stopPropagation();
    isAnimating = false;
    clearAllFilters();
    closeModal(true);
  });

  // --- Hover negative space → show CLOSE overlay ---
  function isCloseZone(target) {
    if (!isAnyFilterActive()) return false;
    if (!target.closest("#filter-groups-wrapper")) return true;
    var group = target.closest(".filter-group");
    if (!group) return false;
    return getComputedStyle(group).display === "none";
  }

  var suppressCloseHover = false;
  filterBar.addEventListener("mouseenter", function () {
    suppressCloseHover = false;
  });
  filterBar.addEventListener("mouseover", function (e) {
    if (suppressCloseHover) { filterBar.classList.remove("close-hover"); return; }
    filterBar.classList.toggle("close-hover", isCloseZone(e.target));
  });
  filterBar.addEventListener("mousemove", function (e) {
    if (suppressCloseHover) { filterBar.classList.remove("close-hover"); return; }
    filterBar.classList.toggle("close-hover", isCloseZone(e.target));
  });
  filterBar.addEventListener("mouseleave", function () {
    filterBar.classList.remove("close-hover");
    suppressCloseHover = false;
  });

  function updateClearBtn() {}

  // --- Combination visibility ---
  // NAME active → hide VIEW ALL, CATEGORY, FINISH
  // CATEGORY or FINISH active → hide VIEW ALL, NAME
  function updateCombinationVisibility() {
    var nameDropdown = document.querySelector("[data-filter='name']");
    var categoryDropdown = document.querySelector("[data-filter='category']");
    var finishDropdown = document.querySelector("[data-filter='finish']");
    var nameActive = nameDropdown && nameDropdown.value;
    var categoryActive = categoryDropdown && categoryDropdown.value;
    var finishActive = finishDropdown && finishDropdown.value;

    if (nameActive) {
      filterBar.classList.add("name-active");
      filterBar.classList.remove("category-finish-active");
    } else if (categoryActive || finishActive) {
      filterBar.classList.add("category-finish-active");
      filterBar.classList.remove("name-active");
    } else {
      filterBar.classList.remove("name-active");
      filterBar.classList.remove("category-finish-active");
    }
  }

  // --- Cross-filter CATEGORY/FINISH options based on current selection ---
  // When CATEGORY is active, hide FINISH options with no matching products, and vice versa.
  function updateAvailableOptions() {
    var categoryDropdown = document.querySelector("[data-filter='category']");
    var finishDropdown = document.querySelector("[data-filter='finish']");
    if (!categoryDropdown || !finishDropdown) return;

    var allContainers = Array.from(document.querySelectorAll("#product-grid-main .product-grid-image-container"));

    function resolveTag(type, value) {
      if (!value) return null;
      var el = document.querySelector("[data-menu-item='" + value + "'][data-menu-type='" + type + "']");
      return el ? extractHandleFromUrl(el.getAttribute("data-menu-url")) : null;
    }

    function availableTagsGiven(activeTag) {
      var pool = activeTag
        ? allContainers.filter(function (c) { return matchesTag(c, activeTag); })
        : allContainers;
      var set = Object.create(null);
      pool.forEach(function (c) {
        (c.dataset.tags || "").split(",").forEach(function (t) {
          var n = normalizeTag(t);
          if (n) set[n] = true;
        });
      });
      return set;
    }

    function filterOptions(targetDropdown, targetType, activeTag) {
      var anyActive = !!activeTag;
      var availableSet = anyActive ? availableTagsGiven(activeTag) : null;
      Array.from(targetDropdown.options).forEach(function (opt) {
        if (!opt.value) return;
        if (!anyActive) {
          opt.hidden = false;
          opt.disabled = false;
          return;
        }
        var tag = resolveTag(targetType, opt.value);
        var available = tag && availableSet[normalizeTag(tag)];
        opt.hidden = !available;
        opt.disabled = !available;
      });
    }

    var categoryTag = resolveTag("category", categoryDropdown.value);
    var finishTag = resolveTag("finish", finishDropdown.value);

    filterOptions(finishDropdown, "finish", categoryTag);
    filterOptions(categoryDropdown, "category", finishTag);
  }

  // --- Clear all filter dropdowns and reset their display ---
  function clearAllFilters() {
    filterDropdowns.forEach(function (dropdown) {
      dropdown.value = "";
    });
    // Remove ALL visibility classes and reset viewAll state BEFORE measuring,
    // so every group is visible when updateDropdownDisplay reads offsetWidth.
    viewAllActive = false;
    filterBar.classList.remove("viewall-active");
    if (viewAllBtn) viewAllBtn.textContent = "VIEW ALL";
    if (viewAllCloseBtn) viewAllCloseBtn.style.display = "none";
    updateCombinationVisibility();
    filterDropdowns.forEach(function (dropdown) {
      updateDropdownDisplay(dropdown);
    });
    updateAvailableOptions();
    updateClearBtn();
  }

  // DISABLED (for now): clicking empty negative space on the grid/body no longer
  // closes the open filter modal. Re-enable by uncommenting.
  // modal.addEventListener("click", function (e) {
  //   if (e.target.closest(".footer-wrapper")) return;
  //   if (!e.target.closest("a") && !isAnimating) {
  //     clearAllFilters();
  //     closeModal();
  //   }
  // });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || modal.style.display !== "block" || isAnimating) return;
    // Defer to the PDP modal when it's open over this filter modal: its own
    // Escape handler history.back()s to restore THIS filtered view. The filter
    // modal is still display:block (just opacity 0) beneath the PDP, so closing
    // it here too would drop the user on the home grid instead of the previous
    // grid. The PDP overlay stays display:block until its 100ms teardown timer,
    // so this reads as open for the whole synchronous keydown. (Literal id —
    // PRODUCT_MODAL.overlayId lives in script-index-product.js.)
    var pdpOverlay = document.getElementById("claustrum-product-modal");
    if (pdpOverlay && pdpOverlay.style.display !== "none") return;
    clearAllFilters();
    closeModal();
  });

  // --- Initialize dropdown event listeners ---
  filterDropdowns.forEach(function (dropdown) {
    dropdown.addEventListener("change", function () {
      updateDropdownDisplay(dropdown);
      updateCombinationVisibility();
      updateAvailableOptions();
      updateClearBtn();
      suppressCloseHover = true;
      filterBar.classList.remove("close-hover");
      applyFilters();
    });
  });

  // --- Set dropdown widths (re-runnable) ---
  // Each .filter-group's children are all position:absolute, so a group has no
  // intrinsic width — it MUST be sized from the placeholder's measured width or
  // the groups collapse and stack. offsetWidth reads 0 while the bar is
  // display:none (cart/PDP open), so bail in that state and re-run once it's
  // shown again (exposed as __measureFilterWidths; called from script-navigation
  // reveal paths + on font load).
  function measureAndSetWidths() {
    // #index-menu display:none → every offsetWidth is 0. Skip so we don't stomp
    // the last good widths with zeros.
    if (filterBar && filterBar.offsetParent === null) return;
    filterDropdowns.forEach(function (dropdown) {
      var container = dropdown.closest('.dropdown-button-container');
      var filterGroup = container ? container.closest('.filter-group') : null;
      var placeholder = container ? container.querySelector('.filter-placeholder') : null;
      // Only re-measure groups currently showing their placeholder (no active
      // selection). A group pinned to a selected label keeps its label width.
      if (!placeholder || placeholder.style.display === 'none') return;
      var w = placeholder.offsetWidth;
      if (w <= 0) return;
      dropdown.style.width = w + 'px';
      if (container) container.style.width = w + 'px';
      if (filterGroup) filterGroup.style.width = w + 'px';
    });
  }
  window.__measureFilterWidths = measureAndSetWidths;
  measureAndSetWidths();
  // Fonts settling after first paint changes label widths — re-measure so the
  // groups don't keep fallback-font widths.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureAndSetWidths);
  }
  window.addEventListener('load', measureAndSetWidths);

  // Note: the NAME-pill display setter was moved to script-navigation.js
  // (HeaderState.setNameDisplay). Consumers should call that directly.

  // --- Handle browser back/forward for filter state ---
  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.filterModal) {
      filterDropdowns.forEach(function (dropdown) {
        var type = dropdown.getAttribute("data-filter");
        var val = e.state[type] || "";
        dropdown.value = val;
        updateDropdownDisplay(dropdown);
      });
      updateCombinationVisibility();
      updateAvailableOptions();
      updateClearBtn();
      applyFilters(false);
    } else if (e.state && e.state.viewAll) {
      // Returning to VIEW ALL (e.g. back-button from a PDP that was opened
      // out of VIEW ALL). Re-open instantly so the user lands on the same
      // grid they left, no fade.
      openViewAll({ pushHistory: false, instant: true });
    } else if (e.state && e.state.productModal) {
      // Forward/back ONTO a PDP entry that sits on top of this collection/filter
      // modal. The PDP overlay (script-index-product.js's popstate) handles
      // (re)opening itself — leave the collection grid beneath it untouched so it's
      // still there when the PDP is later closed.
    } else if (modal.style.display === "block") {
      clearAllFilters();
      closeModal(false);
    }
  });

  // --- Auto-open from URL filter params ---
  var initialParams = new URLSearchParams(window.location.search);
  var hasFilterParam = initialParams.get("name") || initialParams.get("category") || initialParams.get("finish");
  if (hasFilterParam) {
    filterDropdowns.forEach(function (dropdown) {
      var type = dropdown.getAttribute("data-filter");
      var val = initialParams.get(type) || "";
      if (val) {
        dropdown.value = val;
        updateDropdownDisplay(dropdown);
      }
    });
    updateCombinationVisibility();
    updateAvailableOptions();
    updateClearBtn();

    // PRESERVE the deep-link URL (keep ?name=/?category=/?finish= in the address
    // bar) so the filtered view is reloadable and shareable. We do NOT clean it
    // to "/". Instead we ATTACH the matching filterModal state to this initial
    // history entry (a fresh page load lands here with null state). That state is
    // what the popstate handler reads to RE-apply the filter if the user opens a
    // PDP from it and then steps back onto this entry — without it, back would
    // close the modal but leave the filter query stale in the bar. The
    // applyFilters(false) below avoids stacking a duplicate entry on top.
    history.replaceState(
      {
        filterModal: true,
        name: initialParams.get("name") || "",
        category: initialParams.get("category") || "",
        finish: initialParams.get("finish") || "",
      },
      "",
      window.location.pathname + window.location.search
    );

    // Set the header to its filter-bar state FIRST — revealFilters() snaps the
    // logo to visibility:hidden via JS. Only THEN run applyFilters(), which
    // removes the cl-deeplink-hide pre-paint style. Doing it in this order means
    // the logo is already JS-hidden before the early style is dropped, so it
    // never flashes between the two (it used to, because applyFilters removed the
    // style synchronously while revealFilters was deferred to a later tick).
    // revealFilters is wired up in script-navigation.js's DOMContentLoaded block,
    // which (loaded in <head>) registers before this body script — so it's ready.
    if (window.HeaderState.revealFilters) window.HeaderState.revealFilters();
    // pushHistory:false — the URL already reflects the filter (set above); pushing
    // a fresh ?name= entry here would stack a duplicate history entry.
    applyFilters(false);
  } else if (initialParams.get("viewall")) {
    // --- Auto-open VIEW ALL from ?viewall=true ---
    // Mirrors the filter deep-link above: PRESERVE the URL, attach the viewAll
    // state to the initial history entry (so a step-back from a PDP re-opens
    // VIEW ALL via the popstate handler rather than leaving a stale ?viewall=),
    // reveal the bar, then open instantly with pushHistory:false (no duplicate
    // entry). VIEW ALL has no filter dropdowns to seed.
    history.replaceState(
      { viewAll: true },
      "",
      window.location.pathname + window.location.search
    );
    if (window.HeaderState.revealFilters) window.HeaderState.revealFilters();
    // instant:false → VIEW ALL FADES in on a deep-link reload, exactly like the
    // home grid's fadeInHome. (The popstate restore from a PDP still uses
    // instant:true so stepping back doesn't re-animate.)
    openViewAll({ pushHistory: false, instant: false });
    // openViewAll (unlike applyFilters) doesn't drop the pre-paint hide style, so
    // remove it here now the modal + bar are up.
    var viewAllEarlyStyle = document.getElementById("cl-deeplink-hide");
    if (viewAllEarlyStyle) viewAllEarlyStyle.remove();
  }

  // Exposed so the PDP-modal "go home" path (script-index-product.js) can fully
  // dismiss a filter-opened collection back to the bare index — clearing the
  // filter dropdowns + bar state, not just hiding the shared #collection-modal.
  // INSTANT (updateHistory:false branch): the caller runs this behind the still-
  // opaque PDP overlay, so the swap to home must not animate (no collection
  // flash). The caller owns the final URL normalization.
  window.closeFilterModal = function () {
    clearAllFilters();
    closeModal(false);
  };
});

